import { useEffect, useState } from "react";

import Markdown from "react-markdown";

type PageState =
  | { kind: "loading" }
  | { kind: "not found" }
  | { kind: "ready"; content: string };

export default function Page({
  filename,
}: {
  filename: string;
}): React.ReactElement {
  const [state, setState] = useState<PageState>({ kind: "loading" });

  useEffect(() => {
    import(`./content/${filename}`)
      .then((res) =>
        fetch(res.default)
          .then((response) => response.text())
          .then((response) => setState({ kind: "ready", content: response }))
          .catch((err) => console.log(err))
      )
      .catch((e) => setState({ kind: "not found" }));
  }, [filename]);

  switch (state.kind) {
    case "loading":
      return <></>;
    case "not found":
      return <>page not found, check url plz</>;
    case "ready":
      return (
        <article>
          <Markdown>{state.content}</Markdown>
        </article>
      );
  }
}
